import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import WarningIcon from "@mui/icons-material/Warning";
import FormHelperText from "@mui/material/FormHelperText";
import { useForm, useFieldArray } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import Message from "../components/Message";
import { useAuthUser } from "react-auth-kit";
import axios from "axios";
import BtnWhatsapp from "../components/BtnWhatsapp";


export default function ProfessionaExperience({ jobs, updatejob }) {
  const auth = useAuthUser();

  const {
    register,
    watch,
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  //Array de fields
  const { fields, append, remove } = useFieldArray({
    control,
    name: "jobs_array", // unique name for your Field Array
  });

  //Default values
  useEffect(() => {
    reset({
      jobs_array: jobs,
    });
  }, [reset, jobs]);

  const watchCompany = watch("jobs_array.0.USER_EXPERIENCE_COMPANY");

  const onSubmit = (data) => {
    axios
      .patch(`${process.env.REACT_APP_API}/job_experience`, data, {
        headers: {
          Authorization: "Bearer " + auth().token,
        },
      })
      .then((res) => {
        // console.log(res.data);
        updatejob(res.data);
        setAlert(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Delete Job
  const handleDelete = (event, index) => {
    const watchJobId = watch(`jobs_array.${index}.USER_EXPERIENCE_ID`);

    axios
      .delete(
        `${process.env.REACT_APP_API}/job_experience?USER_EXPERIENCE_ID=${watchJobId}`,
        {
          headers: {
            Authorization: "Bearer " + auth().token,
          },
        }
      )
      .then((res) => {
        console.log("Job deleted");
        updatejob(res.data);
        setAlert(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //

  //SnackBar Message
  const [alert, setAlert] = useState(false);
  const message = "As experiências profissionais foram atualizadas com sucesso!";

  return (
    <div>
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container>
        <Grid item xs={12} p={1} align="left">
          <Typography variant="h6" p={1} className="title">
            Experiência Profissional
          </Typography>
        </Grid>
        {fields.map((field, index) => {
          return (
            <Grid container key={index}>
              <Grid item xs={12} pl={1}>
                {!watchCompany && index === 0 && (
                  <Typography align="left">
                    <WarningIcon /> Verificamos que ainda não adicionou a sua
                    experiência profissional!
                  </Typography>
                )}
                {index > 0 && (
                  <Typography align="left">
                    <WarningIcon /> Nova experiência profissional!
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} p={1}>
                <TextField
                  fullWidth={true}
                  id="outlined-required"
                  type="text"
                  label="Empresa"
                  // Rever
                  // error={!!errors.jobs_array}
                  {...register(`jobs_array.${index}.USER_EXPERIENCE_COMPANY`, {
                    required: true,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name={`jobs_array[${index}].USER_EXPERIENCE_COMPANY`}
                  as="p"
                  className="error"
                  message="A experiência profissional é obrigatória."
                />
              </Grid>
              <Grid item xs={12} p={1}>
                <TextField
                  fullWidth={true}
                  id="outlined-required"
                  type="text"
                  multiline
                  rows={4}
                  label="Funções"
                  {...register(`jobs_array.${index}.USER_EXPERIENCE_FUNCTION`, {
                    required: true,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name={`jobs_array[${index}].USER_EXPERIENCE_FUNCTION`}
                  as="p"
                  className="error"
                  message="A função é obrigatória."
                />
              </Grid>
              <Grid item xs={12} sm={6} p={1}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth={true}
                  label="Data início"
                  type="date"
                  {...register(
                    `jobs_array.${index}.USER_EXPERIENCE_FROM_DATE`,
                    {
                      required: true,
                    }
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name={`jobs_array[${index}].USER_EXPERIENCE_FROM_DATE`}
                  as="p"
                  className="error"
                  message="A data inicial é obrigatória."
                />
              </Grid>
              <Grid item xs={12} sm={6} p={1}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth={true}
                  label="Data fim"
                  type="date"
                  {...register(`jobs_array.${index}.USER_EXPERIENCE_TO_DATE`)}
                />
                <FormHelperText
                  id="component-helper-text"
                  sx={{ paddingLeft: "2px;" }}
                >
                  Não preencher caso ainda esteja em funções
                </FormHelperText>
              </Grid>
              <input
                type="hidden"
                {...register(`jobs_array.${index}.JOB_EXPERIENCE_ID`)}
                value={
                  field.USER_EXPERIENCE_COMPANY +
                  "-" +
                  field.USER_EXPERIENCE_FROM_DATE
                }
              />
              <Grid container p={1} className="pe-DeleteBtn">
                
                  <Button
                    variant="contained"
                    onClick={(event) => {
                      handleDelete(event, index);
                      remove(index);
                    }}
                    color="error"
                  >
                    Eliminar
                  </Button>
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={12} p={1}>
          <Button
            type="submit"
            value="submit"
            variant="contained"
            className="btnPrimary"
          >
            Gravar
          </Button>
          <Message
            message={message}
            alert={alert}
            setAlert={(updated) => setAlert(updated)}
          />
          <Button
            p={1}
            onClick={() =>
              append({ JOB_EXPERIENCE_ID: null, USER_EXPERIENCE_TO_DATE: null })
            }
            variant="contained"
            className="fr"
            color="primary"
          >
            Adicionar Mais
          </Button>
        </Grid>
      </Grid>
    </form>
<BtnWhatsapp />
    </div>
  );
}